import {useEffect} from 'react';
import type {FeatureFlagEnum} from 'src/api/ProactApiClient';
import {useAppSelector} from 'src/redux/hooks';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useActiveFeatureFlags from 'src/shared/hooks/useActiveFeatureFlags';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export interface FeatureFlagGuardProps {
  requiredFeatureFlag?: FeatureFlagEnum;
  showDisabledMessage?: boolean;
  children?: React.ReactNode;
}

export const FeatureFlagGuard: React.FC<FeatureFlagGuardProps> = ({
  requiredFeatureFlag,
  showDisabledMessage = false,
  children,
}) => {
  const navigate = useAppNavigate();
  const {session} = useAppSelector(state => state.session);
  const activeFeatureFlags = useActiveFeatureFlags();

  const flagsReady = session?.instance?.activeFeatures != null;
  const allowed =
    requiredFeatureFlag === undefined ||
    activeFeatureFlags?.includes(requiredFeatureFlag) === true;

  useEffect(() => {
    if (flagsReady && !allowed && showDisabledMessage === true) {
      navigate(PathUtility.PermissionDenied());
    }
  }, [flagsReady, allowed, showDisabledMessage, navigate]);

  if (allowed) {
    return <>{children}</>;
  }

  return null;
};
